// SensorFormModal.jsx
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";

export default function SensorFormModal({
  sensor,
  mcus,
  isOpen,
  onClose,
  onSubmit,
  loading
}) {
  const { register, handleSubmit, reset, formState: { errors } } = useForm();

  useEffect(() => {
    if (sensor) {
      reset({
        mac: sensor.mac || "",
        name: sensor.name || "",
        type: sensor.type || "",
        mcu_id: sensor.mcu_id || ""
      });
    }
  }, [sensor, reset]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 backdrop-blur-sm backdrop-brightness-75 flex justify-center items-center">
      <div className="bg-white rounded-xl p-6 w-full max-w-md relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-red-600">
          <FiX />
        </button>
        <h2 className="text-lg font-bold mb-4">{sensor?.sensor_id ? "Edit Sensor" : "Add Sensor"}</h2>

        {loading ? (
          <p>Loading…</p>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <div>
              <label className="block text-sm font-medium">Name</label>
              <input {...register("name")} className="w-full px-3 py-2 border rounded-lg" />
            </div>

            <div>
              <label className="block text-sm font-medium">MAC</label>
              <p className="px-3 py-2 bg-gray-100 rounded-lg font-mono">
                {sensor?.mac || ""}
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium">Type</label>
              <select {...register("type", { required: "Type required" })} disabled className="w-full px-3 py-2 border rounded-lg peer-read-only ">
                <option value="">Select type</option>
                {["CO2", "Humidity", "Soil_temp", "Moisture"].map(t => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
              {errors.type && <p className="text-red-500 text-sm mt-1">{errors.type.message}</p>}
            </div>

            <div>
              <label className="block text-sm font-medium">Assign to MCU</label>
              <select {...register("mcu_id", { required: "MCU required" })} className="w-full px-3 py-2 border rounded-lg">
                <option value="">-- select MCU --</option>
                {mcus.map(m => (
                  <option key={m.mcu_id} value={m.mcu_id}>{m.name} ({m.mac})</option>
                ))}
              </select>
              {errors.mcu_id && <p className="text-red-500 text-sm mt-1">{errors.mcu_id.message}</p>}
            </div>

            <div className="flex justify-end space-x-3 pt-4">
              <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-100 rounded-lg hover:bg-gray-200">Cancel</button>
              <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
                {sensor?.sensor_id ? "Update" : "Create"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
